import { StatusBar } from "expo-status-bar";

import { isAndroid } from "@/utils/platform.util";

const EquipStatusBar = () => {
  const AndroidStatusBarProps = isAndroid()
    ? {
        isTranslucent: true,
      }
    : {};

  return (
    <StatusBar style="dark" translucent={AndroidStatusBarProps.isTranslucent} />
  );
};

export default EquipStatusBar;
